module.exports = __webpack_public_path__ + "static/media/frontend_blackhole_compressed.4b2d7fa9.png";